import { storageGetJson, storageSet } from '@/utils/safe-storage.js';

export function useRefreshResultsStorage(uid) {
    const key = `refresh-results-${uid}`;

    function get() {
        return storageGetJson(key) ?? {};
    }

    function set(data) {
        storageSet(key, JSON.stringify({ ...get(), ...data }));
    }

    return { get, set };
}
